import getCookie from '../common/getCookie'
import setCookie from '../common/setCookie'
import { getCookieDomain } from '../functions/ams-functions'

export const APP_CONFIG_KEY = 'ICC-appConfig'
// js-cookie treats a missing `expires` as a session cookie, so without this the
// flag that gates the Android cookie flush and the app's X-Context platform
// header dies whenever the WebView's cookie session ends — often well before
// the next cold start that needs it. 365 days is effectively "persistent" and
// within every browser's cookie-lifetime cap.
const APP_CONFIG_COOKIE_EXPIRY_DAYS = 365
enum SYSTEM {
    Web = 'Web',
    MOBILE_APP = 'mobileApp',
}

export interface IAppConfig {
    isMobileApp: boolean
    hideSSO: boolean
    useNativeSSO: boolean
    hideCookies: boolean
    hideMemberships: boolean
    hideFullScreenToggle: boolean
    hideAccountDeletion: boolean
}

const setAppConfigCookie = (props: IAppConfig, domain: string) => {
    const data = JSON.stringify(props)
    setCookie(APP_CONFIG_KEY, data, getCookieDomain(domain), APP_CONFIG_COOKIE_EXPIRY_DAYS)
}

const setAppConfigStorage = (props: IAppConfig) => {
    const data = JSON.stringify(props)
    localStorage.setItem(APP_CONFIG_KEY, data)
}

export const getAppConfig = (): IAppConfig | null => {
    const cookieData = getCookie(APP_CONFIG_KEY)
    const storageData = localStorage.getItem(APP_CONFIG_KEY)
    if (cookieData) {
        if (storageData && cookieData === storageData) {
            return JSON.parse(storageData)
        } else {
            const parsedData = JSON.parse(cookieData)
            if (parsedData) {
                setAppConfigStorage(parsedData)
            }
            return parsedData
        }
    } else {
        if (storageData) {
            return JSON.parse(storageData)
        }
    }

    return {
        isMobileApp: false,
        hideSSO: false,
        useNativeSSO: false,
        hideCookies: false,
        hideMemberships: false,
        hideFullScreenToggle: false,
        hideAccountDeletion: true,
    }
}

export const useConfig = (param: string, domain: string) => {
    if (param && param.toLowerCase() === SYSTEM.MOBILE_APP.toLowerCase()) {
        const data: IAppConfig = {
            isMobileApp: true,
            // Hides web-SDK SSO only (incl. website copies that check nothing else);
            // native SSO is gated by the app build's declared providers (ADR-018).
            hideSSO: true,
            useNativeSSO: true,
            hideCookies: true,
            hideMemberships: true,
            hideFullScreenToggle: true,
            hideAccountDeletion: false,
        }
        setAppConfigCookie(data, domain)
        setAppConfigStorage(data)
    }
}
